import type { IconSvgObject } from './types';

const FlameKindlingIcon: IconSvgObject = [
  ["path", { d: "M12 15C14.7614 15 17 12.8174 17 10.125C17 9.475 17 8.175 15.6667 6.55C15.6667 6.55 15.6003 8.40484 14.2842 8.13653C12.1554 7.70256 14.9034 3.62692 11 2C11 5.25 7 6.225 7 10.125C7 12.8174 9.23858 15 12 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22L20 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 22L3.99997 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlameKindlingIcon;
